import axios from "axios";
import { makeRequest, networkGlobals } from "./networkUtils";
import { getBrandsDO } from "./brandsUtils";
import { Language } from "models/content/Language";
import { Translation } from "models/content/Translation";


function getHost() {
    return networkGlobals.serverHost;
}

export const getTranslationsByInputDO = async (host, lang, letter, brandID, page):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`${networkGlobals.serverHost}/api/translate/byInput/?host=${host}&lang=${lang}&letter=${letter}&brandID=${brandID}&page=${page}`)
            .then(res => {
                resolve(res?.data?.rows);
            })
            .catch(error => {
                console.error('error from get translations:', error)
                reject(error);
            })
    })
}

export const getTranslationsByStatusDO = async (host, lang, status, page, brandID):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`${networkGlobals.serverHost}/api/translate/byStatus/?host=${host}&lang=${lang}&status=${status}&brandID=${brandID}&page=${page}`)
            .then(res => {
                resolve(res?.data?.rows);
            })
            .catch(error => {
                console.error('error from get translations:', error)
                reject(error);
            })
    })
}

export const getTranslationsByLetterDO = async (host, lang, letter, page, brandID, excludeList):Promise<any> => {
    return new Promise((resolve, reject) => {
        ;
        axios.post(`${networkGlobals.serverHost}/api/translate/byLetter`, { host, lang, letter, brandID, excludeList, page })
            .then(res => {
                resolve(res?.data?.rows);
            })
            .catch(error => {
                console.error('error from get translations:', error)
                reject(error);
            })
    })
}

export const getTranslationsByPositionsDO = async (host, lang, position?, page?, brandID?):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get(`${networkGlobals.serverHost}/api/translate/byType/?host=${host}&lang=${lang}&position=${position}&page=${page}&brandID=${brandID}`)
            .then(res => {
                resolve(res?.data?.rows);
            })
            .catch(error => {
                console.error('error from get translations:', error)
                reject(error);
            })
    })
}

export const deleteTeanslationDO = async (host, translation, brandID):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`${networkGlobals.serverHost}/api/translate/delete/`, { host, translation, brandID })
            .then(res => {
                ;
                resolve(res);
            })
            .catch(error => {
                console.error('error from get translation positions:', error)
                reject(error);
            })
    })
}

export const deployTranslationsDO = async (host, brandName, brandID):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`${networkGlobals.serverHost}/api/translate/deploy/`, { host, brandName: brandName.toLowerCase(), brandID })
            .then(res => {
                ;
                resolve(res);
            })
            .catch(error => {
                console.error('error from get translation positions:', error)
                reject(error);
            })
    })
}

/** copy translateions */
export const copyTranslationDO = async (host, brandID, translation, userID):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post(`${networkGlobals.serverHost}/api/translate/translationCopy/`, { host, brandID, translation, userID })
            .then(res => {
                ;
                resolve(res);
            })
            .catch(error => {
                console.error('error from get translation positions:', error)
                reject(error);
            })
    })
}

/** add new translation */
export const addNewTranslationDO = async (translation: Partial<Translation>):Promise<any> => {
    return Promise.all(["dev","prod"].map(async (host) => 
    makeRequest('translations?host='+host, {
        method: 'POST',
        body: translation
        })))
}

export const translationsLanguagesDO = async ():Promise<Language[]> => {
    return makeRequest('languages')
    // return new Promise((resolve, reject) => {
    //     ;
    //     axios.get(`${networkGlobals.serverHost}/api/translate/translationsLangusages/?host=${host}`)
    //         .then(res => {
    //             resolve(res?.data?.rows);
    //         })
    //         .catch(error => {
    //             console.error('error  from get new trans langs:', error)
    //             reject(error);
    //         })
    // })
}

export const addNewTranslationLangDO = async (host, data):Promise<any> => {
    return new Promise((resolve, reject) => {
        ;
        axios.post(`${networkGlobals.serverHost}/api/translate/addNewLang`, { host, data })
            .then(res => {
                resolve(res?.status);
            })
            .catch(error => {
                console.error('error from add new permission:', error)
                reject(error);
            })
    })
}

/** update completed status */
export const updateIsCompletedStatuDO = async (host, id, status):Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.put(`${networkGlobals.serverHost}/api/translate/completed`, { id, host, status })
            .then(res => {
                resolve(res?.status);
            })
            .catch(error => {
                console.error('error from put translate DO:', error)
                reject(error);
            })
    })
}

/** update completed status */
export const updateContent = async (id, description, positions, lang) => {
    return makeRequest(`translations/${id}?lang=${lang || ""}`,{method: 'PUT', body: {description, positions}});
}

/** update completed status */
export const publishLangsDO = async (lang) => {
    return makeRequest('translations/publish?lang='+(lang || "en"),{method: 'POST'});
}


export const publishLangsList = async () => {
    return makeRequest('languages/publish',{method: 'POST'});
}